import { Button as AntdButton } from 'antd';
import type { ButtonProps as AntdButtonProps } from 'antd/es/button';
import { forwardRef, MouseEvent } from 'react';

import { trackEvent } from 'utils/analytics';

import { useAuthStore } from 'store/auth.store';
import { useWorkspaceStore } from 'store/workspace.store';

export interface ButtonProps extends AntdButtonProps {
  fullWidth?: boolean; // already using fullWidth in multiple places
  message?: {
    eventName: string;
    properties?: Record<string, any>;
  };
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { workspace } = useWorkspaceStore();
  const { user } = useAuthStore();

  const { fullWidth, block, message, onClick, ...rest } = props;

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    trackEvent(message?.eventName ?? 'Button Click', {
      ...(message?.properties ?? {}),
      action_type: 'button',
      user_email: user?.email ?? '',
      user_name: user?.displayName ?? '',
      organization_id: workspace?.id ?? '',
      organization_name: workspace?.name ?? '',
      organization_email_domain: workspace?.email_domain ?? '',
    });

    // Call the original onClick if it exists
    onClick?.(e);
  };

  return (
    <AntdButton
      {...rest}
      ref={ref}
      block={fullWidth || block}
      onClick={handleClick}
    >
      {props.children}
    </AntdButton>
  );
});

Button.displayName = 'Button';

export { Button };
